import { checkNullData } from '../utils';
import {
    getDatesDifference, getFirstDayOfYear, getTimestamp, subtractUnits,
} from '../utils/datetime';
import { adaptPlotsAmount } from '../utils/adaptPlotsAmount';
import { sorterByDateCommon } from '../utils/sorting';
import { adaptStartDate, isNeedToAddFlatLine } from '../utils/charts';

const adaptDate = (Date) => getTimestamp(Date);

export const adaptPlotsChart = ({
    data,
    chartStartDate,
    chartEndDate,
    adaptValue,
    useFirstValueForFlat,
} : any) => {
    if (checkNullData(data) || checkNullData(data)) return [];

    const lastDate = data[data.length - 1].Date;
    const isReversedArray = getDatesDifference(lastDate, data[0].Date, 'days') < 0;
    const dateToCompare = isReversedArray ? lastDate : data[0].Date;
    const needDivide = chartStartDate ? getDatesDifference(chartStartDate, dateToCompare, 'days') > 0 : false;
    const isFirstDayOfYear = chartStartDate === getFirstDayOfYear();

    let valueToDivideIdx: number | null = null;
    let valueToDivide: any = null;

    if (needDivide) {
        valueToDivideIdx = data.findIndex(({ Date }) => {
            const diff = getDatesDifference(Date, chartStartDate, 'days');

            return isReversedArray ? diff <= 0 : diff >= 0;
        });

        if (isFirstDayOfYear && !isReversedArray) {
            valueToDivideIdx = valueToDivideIdx as number - 1;
        }

        valueToDivide = data[valueToDivideIdx as number];
    }

    const initValues = needDivide
        ? data.filter((item, idx) => (isReversedArray
            ? idx <= (valueToDivideIdx as number) : idx >= (valueToDivideIdx as number)))
        : data;

    let values = adaptPlotsAmount(initValues);

    if (isReversedArray) {
        values = values.sort(sorterByDateCommon('Date'));
    }

    const adaptedData: any[] = [];

    values.forEach((item, idx) => {
        const { Date } = item;

        if (idx === 0) {
            const start = adaptStartDate(chartStartDate, Date);
            const value = useFirstValueForFlat
                ? adaptValue(item, { valueToDivide, firstValue: values[0] }) : 0;

            if (isNeedToAddFlatLine(start, Date)) {
                adaptedData.push([adaptDate(start), value]);
                adaptedData.push([adaptDate(subtractUnits(Date, 1, 'days')), value]);
            }
        }

        if (valueToDivide && getDatesDifference(Date, valueToDivide.Date, 'days') < 0) {
            return;
        }

        if (chartEndDate && getDatesDifference(Date, chartEndDate, 'days') > 0) {
            return;
        }

        adaptedData.push([
            adaptDate(Date),
            adaptValue(item, { valueToDivide, firstValue: values[0] }),
        ]);
    });

    return adaptedData;
};
